export const GO_TO_PAGE_APPLICATION = 'GO_TO_PAGE_APPLICATION';
export const UPDATE_PAGE_PROGRESS = 'UPDATE_PAGE_PROGRESS';
export const CREATE_PAGE_PROGRESS_MAP = 'CREATE_PAGE_PROGRESS_MAP';
export const REVIEW_APPLICATION_PAGE = 'REVIEW_APPLICATION_PAGE';
